module.exports = __webpack_public_path__ + "static/media/ic-sort-za-white.4988aea7.svg";